import { render, staticRenderFns } from "./questionBank.vue?vue&type=template&id=093d27c0&scoped=true&"
import script from "./questionBank.vue?vue&type=script&lang=js&"
export * from "./questionBank.vue?vue&type=script&lang=js&"
import style0 from "./questionBank.vue?vue&type=style&index=0&id=093d27c0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "093d27c0",
  null
  
)

export default component.exports